/**
 * Engineering Page Animation.
 */
 const engineeringAnimation = () => {
  const engineeringPage = document.querySelector('.engineering');
  const recruitPage = document.querySelector('.recruit');

  // Return if not engineering page.
  if (!engineeringPage && !recruitPage) return;

  // Get the circles to animate.
  const circles = document.querySelectorAll('.engineering__scope-circle');

  // ------------- Intersection Observer ---------------- //

  // Intersection Observer OPTIONS.
  const options = {
    root: null,
    threshold: 0,
  };

  // Intersection Observer CALLBACK.
  const callback = function (entries:any) {
    const [entry] = entries;

    // Add or remove animate class based on visibility.
    if (entry.isIntersecting) circles.forEach((circle:any) => circle.classList.add('animate'));
    else circles.forEach((circle:any) => circle.classList.remove('animate'));
  };

  // Initiate intersection observer API.
  const target = document.querySelector('.engineering__scope-circle.big') as any;
  const scopeObserver = new IntersectionObserver(callback, options);
  scopeObserver.observe(target);
};

export default engineeringAnimation;